import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Util } from '../util.service';

@Injectable({
  providedIn: 'root'
})

export class QuestionService {
  baseurl = Util.GetBaseUrl();

  constructor(private http: HttpClient,public router: Router) { }

  viewQuestion() {
    return this.http.get(this.baseurl +'/api/Questions/GetQuestions')
  }

  addQuestion(questionForm) {
    console.log(questionForm);
    return this.http.post(this.baseurl+'/api/Questions', questionForm)
  }

  editQuestion(id, questionForm) {
    console.log(questionForm);
    return this.http.put(this.baseurl +`/api/Questions/${id}`, questionForm)
  }

  deleteQuestion(id) {
    console.log(id);
    return this.http.delete(this.baseurl+`/api/Questions/${id}`)
  }

  //Only Works on GDP Picture branch probably
  downloadQuestions() { 
    return this.http.get(this.baseurl+'/api/questionpdf ', { responseType: 'blob'})
  }

  //Only Works on GDP Picture branch probably
  downloadAnswers() { 
    return this.http.get(this.baseurl+'/api/answerpdf', { responseType: 'blob'})
  }
}
